import Vue from 'vue'
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

const es = {
  dataIterator: {
    rowsPerPageText: 'Elementos por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se encontraron resultados',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior',
  },
  dataTable: {
    rowsPerPageText: 'Filas por página:',
  },
  noDataText: 'No hay datos disponibles',
  datePicker: {
    itemsSelected: '{0} seleccionados',
  },
}

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { es },
    current: 'es',
  },
})
